import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { TimeIcon } from 'static/icons';
import { getDurationMessage } from 'utils';
import { GroupEventInfo, ServiceInfo } from 'types';
// eslint-disable-next-line import/no-duplicates
import { addSeconds, format, parse } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';

export const InfoEventHeader: React.FC<{
  event: GroupEventInfo;
  service?: ServiceInfo;
  isAvailable: boolean;
}> = ({ event, service, isAvailable }) => {
  const textColor = isAvailable ? 'asphalt.8' : 'disabledText';
  const { date, duration: eventDuration, time, visitStarted } = event;
  const {
    duration = 0,
    price,
    priceInterval,
    showDuration,
    showPrice,
  } = service || {};
  return (
    <Flex h="100%" flexDirection="column" justifyContent="space-between">
      <Text
        color={textColor}
        textStyle="body2"
        lineHeight="1.25rem"
        fontSize="0.75rem"
        fontWeight={600}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        gridGap={1}
      >
        {visitStarted ? (
          format(
            addSeconds(parse(time, 'HH:mm', new Date(date)), eventDuration),
            'до HH:mm',
            {
              locale: ru,
            },
          )
        ) : (
          <>
            <TimeIcon />
            {time}
          </>
        )}
      </Text>
      <div>
        {showDuration && (
          <Text
            color={textColor}
            textStyle="body2"
            fontSize="0.625rem"
            textAlign="right"
            lineHeight={showPrice ? undefined : '1.5rem'}
          >
            {getDurationMessage(duration)}
          </Text>
        )}
        {showPrice && price ? (
          <Text
            color={textColor}
            textStyle="body1"
            fontSize="0.75rem"
            textAlign="right"
            mt="2px"
          >
            {`${priceInterval ? 'от ' : ''}${price}₽`}
          </Text>
        ) : null}
      </div>
    </Flex>
  );
};
